import type { AcademyAccountSession } from "@tradvera/academy-domain";
import { MyPortfolioNextConnected } from "@tradvera/my-portfolio-next/ui";

/** Single portfolio frontend entry used by both the owner portal and admin shell. */
export function MyPortfolioEntry({ account }: { account: AcademyAccountSession }) {
  return <MyPortfolioNextConnected account={account} initialBookKind="OWNED_PRIVATE" />;
}
